'use strict';

namespace ekh {

    class FooterCookies {
        show: boolean;

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            )
        {
        }

        init (container : ng.IAugmentedJQuery) {
            this.broker.subscribe('footerCookies', 'showFooterCookies', e => {
                this.show = true;
                let header = (document.querySelectorAll('.header-wrapper') as any as HTMLElement[])[0];
                let selectionToolbar = (document.querySelectorAll('.selection-toolbar') as any as HTMLElement[])[0];
                let mainCol = (document.querySelectorAll('.main-col') as any as HTMLElement[])[0];
                header.style.zIndex = '0';
                selectionToolbar.style.zIndex = '0';
                mainCol.style.zIndex = '0';

                let cookieModal = document.querySelectorAll('.cookie-modal')[0];
                let close = cookieModal.querySelectorAll('.close')[0];

                close.addEventListener('click', function(e) {
                    header.removeAttribute('style');
                    selectionToolbar.removeAttribute('style');
                    mainCol.removeAttribute('style');
                });
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('footerCookies');
            });
        }

        showCookiePopup() {
            this.broker.publish('showFooterCookies');
        }

    }

    angular
        .module('core')
        .directive('footerCookies', (): ng.IDirective => {

            return {
                scope: {},
                controller: FooterCookies,
                controllerAs: 'fc',
                templateUrl: 'partials/home/directivetemplate?type=FooterCookies',
                bindToController: {
                    popupContent: '='
                },
                link: function (
                    scope : ng.IScope,
                    el : ng.IAugmentedJQuery,
                    attr,
                    controller : FooterCookies) {
                    controller.init(el);
                }
            };
    });

}

